'use client';

import Script from 'next/script';
import { useEffect } from 'react';

import { logger } from '@abg/logger';
import { refreshAdobeWebSDKView } from '@abg/web-core/adobe-target-client/helpers';
import { getClientEnvironmentVariable } from '@abg/web-core/utils/get-client-environment-variable/get-client-environment-variable';

import { waitForElm } from './helpers/wait-for-element';
import {
  NEXT_PUBLIC_ADOBE_EDGE_CONFIG_ID_KEY,
  NEXT_PUBLIC_ADOBE_ORG_ID_KEY,
  PAGE_ID,
} from './constants';

// Prehiding is owned by the inline <style id="alloy-prehiding"> in <head>.
// alloy removes that element after sendEvent({renderDecisions:true}) resolves
// regardless of whether alloy or the page created it, so passing prehidingStyle
// into alloy('configure') would just re-inject the style if our page-level
// fail-safe timeout already removed it — producing a second hide/show flash.
export const AdobeTargetScript = () => {
  useEffect(() => {
    // we need to wait until loading screen ends and our
    // rendered html content appears for target to inject p13n html
    Promise.all([
      waitForElm(`#${PAGE_ID}`),
      waitForElm('[data-testid="topherobanner-headline"]'),
    ])
      .then(() => {
        logger.info('start personalization refres');
        return refreshAdobeWebSDKView();
      })
      .catch(() => {
        logger.error('personalization was not refreshed');
      });
  }, []);

  return (
    <>
      <Script
        id="adobe-alloy-websdk"
        src={`/_static/scripts/alloy.js?v=${process.env['NEXT_PUBLIC_BUILD_ID']}`}
        strategy="afterInteractive"
        onLoad={() => {
          if (globalThis.alloy) {
            const alloyConfig = {
              edgeConfigId:
                process.env[NEXT_PUBLIC_ADOBE_EDGE_CONFIG_ID_KEY] ??
                getClientEnvironmentVariable(
                  NEXT_PUBLIC_ADOBE_EDGE_CONFIG_ID_KEY,
                ) ??
                '',
              orgId:
                process.env[NEXT_PUBLIC_ADOBE_ORG_ID_KEY] ??
                getClientEnvironmentVariable(NEXT_PUBLIC_ADOBE_ORG_ID_KEY) ??
                '',
            };

            void globalThis.alloy('configure', alloyConfig).then(() => {
              logger.info(
                'Adobe Alloy Web SDK configured successfully, refreshing view',
              );
              return refreshAdobeWebSDKView();
            });
          }
        }}
      />
    </>
  );
};
